import { apiFetch } from 'services/apiClient';

import type { CreateDistrictDto, District } from '../types/District';

export const listDistrictsByActive = (active = true): Promise<District[]> =>
  apiFetch('/districts?active=' + active);

export const listDistrictsByState = (stateId: number, active = true): Promise<District[]> =>
  apiFetch('/states/' + stateId + '/districts?active=' + active);

export const getDistrict = (id: number): Promise<District> =>
  apiFetch('/districts/' + id);

export const createDistrict = (data: CreateDistrictDto): Promise<number> =>
  apiFetch('/districts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const updateDistrict = (id: number, data: CreateDistrictDto): Promise<void> =>
  apiFetch('/districts/' + id, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const deleteDistrict = (id: number): Promise<void> =>
  apiFetch('/districts/' + id, { method: 'DELETE' });

export const setDistrictActive = (id: number, isActive: boolean): Promise<void> =>
  apiFetch('/districts/' + id + '/active', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ isActive }),
  });
